import tjFetch from '@common-libs/tj-fetch'

// apiConfig
let apiConfig = {}
// 回传小红书信息
apiConfig.xhsexposure = '/bnbapp-node-h5/h5/xhs/exposure'

let api = {}

api.xhsexposure = function() {
  return tjFetch.post(apiConfig.xhsexposure, {
    data: arguments[0]
  })
}

export default api
